import { ElementRef, Injectable } from '@angular/core';
import { JobService } from './job.service';
import { WindowRef } from './window-ref';

const LOGO = '<div class="printDisclaimer_logo"></div>';

const LAYOUT = `
    <div class="printWrapper">
        <div class="printToolbar force-hidden">
            <div class="form-group">
                <div class="text-right btnWrapper">
                    <input class="text-center btn btn--primary" onclick="window.print()" type="button" value="Drucken">
                </div>
            </div>
        </div>
        <div class="printBefore">
            {{logo}}
            {{beforePrint}}
        </div>
        <div class="printContent">
            {{content}}
        </div>
        <div class="printAfter">
            {{afterPrint}}
        </div>
    </div>
`;

/**
 * Die Service offnet ein neues Fenster mit bestimmten Content, damit wird eine Druckfunktion darstellt.
 */
@Injectable()
export class PrintService {

    constructor(private windowRef: WindowRef,
                private jobService: JobService) {
    }

    /**
     * @note Besser ElementRef statt content, wenn es möglich ist
     */
    openPrintWindow(content: string | ElementRef, title: string = '', before: string = '', after: string = '',
                    logo = LOGO): Promise<Window> {
        const printWindow = this.windowRef.nativeWindow.open('', 'printWindow', 'resizable,scrollbars');
        return this.jobService.beforePrint
            .emit()
            .then(() => {
                if (typeof content === 'object') {
                    content = content.nativeElement.innerHTML;
                }
                const layout = this.getLayout(<string> content, before, after, logo);
                this.setStyleTags(printWindow);
                printWindow.document.body.innerHTML = layout;
                printWindow.document.title = title;
                printWindow.focus();

                this.jobService.afterPrint.emit();

                return printWindow;
            });
    }

    private getLayout(content: string, before: string, after: string, logo: string): string {
        let layout = LAYOUT;
        layout = layout.replace('{{content}}', content);
        layout = layout.replace('{{beforePrint}}', before);
        layout = layout.replace('{{afterPrint}}', after);
        layout = layout.replace('{{logo}}', logo);

        return layout;
    }

    /**
     * Kopieren CSS Datein aus dem Window Objekt
     */
    private setStyleTags(printWindow: Window) {
        const printHead = printWindow.document.head;
        Array.from(this.windowRef.nativeWindow.document.head.children)
            .filter((x: any) => {
                return x.nodeName === 'LINK' && x.rel === 'stylesheet';
            })
            // .map(x => printWindow.document.importNode(x, true)) // funktioniert nicht im IE
            .map((x: any) => {
                // printWindow ist wichtig: http://stackoverflow.com/questions/17017682/appendchild-not-working-with-window-open-in-ie
                const link = printWindow.document.createElement('link');
                link.setAttribute('href', x.href);
                link.setAttribute('rel', x.rel);
                return link;
            })
            .forEach(x => printHead.appendChild(x));
    }
}
